class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Home BAEsic: on desktop, open the mega menu on hover as well as click.
    // Keep the existing click/toggle behavior and leave mobile navigation untouched.
    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch') return;
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    });

    // Close only when the pointer actually leaves the entire menu component.
    // Using pointerout + relatedTarget prevents the mega menu from collapsing
    // while the pointer travels from the top-level label into the absolute
    // positioned mega-menu panel. A short delay also makes the transition
    // forgiving for slower mouse movement.
    this.addEventListener('pointerout', (event) => {
      if (event.pointerType === 'touch') return;
      if (!window.matchMedia('(min-width: 990px)').matches) return;

      const nextTarget = event.relatedTarget;
      if (nextTarget && this.contains(nextTarget)) return;

      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = setTimeout(() => {
        if (!this.matches(':hover')) this.close();
      }, 350);
    });

    this.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      clearTimeout(this.hoverCloseTimer);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
